// extracted by mini-css-extract-plugin
export default {"root":"PbfxsY","position-fixed":"Ph4B_9","positionFixed":"Ph4B_9","lightbox-layer":"KJPShO","lightboxLayer":"KJPShO"};